module.exports = __webpack_public_path__ + "img/calligraphy-east.b5d6f8d2.png";